import React, { useEffect, useRef, useState } from 'react';
import { Form, Input, Select, Typography } from 'antd';
import { SkinOutlined } from '@ant-design/icons';
import ReactDOM from 'react-dom';
import DdnHeField from '../components/DdnHeField';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { DefaultValueProvider,FixedValueProvider } from './index';

const { Text } = Typography;

export default (formPlugin, namespace) => {

    return {
        Renderer: (props) => {
            let containerRef = useRef(null)
            const [listField, setlistField] = useState(undefined)
            useEffect(() => {
                setlistField(props.pluginConfig.getListField(containerRef.current))
            }, [])

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const { data } = props
            var reducedWidth = data.reduced ? "48%" : "100%"
            const listFieldProps = listField ? { ...listField, key: undefined } : null
            const finalName = "[CHILD]_" + data.fieldKey
            const extraName = listField ? [listField.name, finalName].flat() : finalName

            return (
                <div ref={(ref) => containerRef.current = ref}>

                    <Form.Item noStyle shouldUpdate={true}>
                        {(_form) => {

                            let _defaultValue=undefined
                            var fixedGenre = false
                            if (data.fixedGenre === "Homme" || data.fixedGenre === "Femme") {
                                fixedGenre = true
                                _defaultValue=data.fixedGenre === "Homme"
                            }

                            return (
                                <Form.Item
                                    {...listFieldProps}
                                    label={t`Garçon / Fille` + " :"}
                                    name={listField ? [listField.name, finalName, "homme"].flat() : [finalName, "homme"]}
                                    rules={[{
                                        required: data.required,
                                        message: t`Ce champ est obligatoire`
                                    }]}
                                >
                                    <FixedValueProvider defaultValue={_defaultValue}>
                                        <Select disabled={fixedGenre} size="large" placeholder={t`Garçon / Fille`}>
                                            <Select.Option value={true}><Trans>Garçon</Trans></Select.Option>
                                            <Select.Option value={false}><Trans>Fille</Trans></Select.Option>
                                        </Select>
                                    </FixedValueProvider>
                                </Form.Item>
                            )
                        }}
                    </Form.Item>

                    <div style={{ display: data.reduced ? "flex" : "block", justifyContent: "space-between" }}>

                        <Form.Item
                            {...listFieldProps}
                            label={(data.labelPrenom || t`Prénom`) + " :"}
                            name={listField ? [listField.name, finalName, "prenom"].flat() : [finalName, "prenom"]}
                            rules={[{
                                required: data.required,
                                message: t`Ce champ est obligatoire`
                            }, {
                                pattern: /^[A-zÀ-ú\s]*$/,
                                message: t`Le champ doit contenir uniquement des lettres`
                            }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={data.labelPrenom || t`Prénom`} />
                        </Form.Item>

                        <Form.Item
                            {...listFieldProps}
                            label={(data.labelNom || t`Nom`) + " :"}
                            name={listField ? [listField.name, finalName, "nom"].flat() : [finalName, "nom"]}
                            rules={[{
                                required: data.required,
                                message: t`Ce champ est obligatoire`
                            }, {
                                pattern: /^[A-zÀ-ú\s]*$/,
                                message: t`Le champ doit contenir uniquement des lettres`
                            }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={data.labelNom || t`Nom`} />
                        </Form.Item>

                    </div>

                    <div style={{
                        display: (data.reduced && props.device === "DESKTOP") ? "flex" : "block",
                        justifyContent: "space-between"
                    }}>
                        <Form.Item
                            {...listFieldProps}
                            label={(data.labelDdn || t`Date de naissance`) + " :"}
                            name={listField ? [listField.name, finalName, "ddn"].flat() : [finalName, "ddn"]}
                            rules={[{
                                required: data.required,
                                message: t`Ce champ est obligatoire`
                            }]}
                            style={{ width: (data.reduced && props.device === "DESKTOP") ? reducedWidth : "100%" }}
                        >
                            <DdnHeField placeholder={data.labelDdn || t`Date de naissance`} />
                        </Form.Item>
                    </div>

                    {listField !== undefined && (
                        <div className="form-field" data-field={JSON.stringify({ key: extraName, name: extraName })}>
                            {props.children}
                        </div>
                    )}
                </div>
            )
        },
        namespace: namespace,
        id: 'form-child' + namespace,
        title: t`Champ Enfant`,
        description: t`Élément de formulaire utilisable.`,
        icon: <SkinOutlined />,
        iconColor: "#F39C12",
        version: 1,
        getListField: (containerRef) => {
            const listField = ReactDOM.findDOMNode(containerRef)?.closest(".form-field")?.dataset.field
            if (listField) return JSON.parse(listField)
            return null
        },
        cellPlugins: (plugins, data) => {
            const initialPlugins = formPlugin.getPluginsMem(namespace).filter(i =>
                !i.id.includes("form-contact") &&
                !i.id.includes("form-child") &&
                !i.id.includes("form-hazkara") &&
                !i.id.includes("form-identity") &&
                !i.id.includes("form-product") &&
                !i.id.includes("form-step-container") &&
                !i.id.includes("form-submit-button") &&
                !i.id.includes("form-free-amount") &&
                !i.id.includes("form-paiement-method") &&
                !i.id.includes("form-calendar")
            )
            return [...initialPlugins, ...formPlugin.getContactFormPlugins(namespace)]
        },
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },
                    reduced: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Formulaire Réduit`,
                        }
                    },
                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du Champ`,
                        }
                    },
                    labelNom: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Nom`,
                            placeholder: t`Étiquette Nom`,
                        }
                    },
                    labelPrenom: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Prénom`,
                            placeholder: t`Étiquette Prénom`,
                        }
                    },
                    labelDdn: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Date de naissance`,
                            placeholder: t`Étiquette Date de naissance`,
                        }
                    },
                    fixedGenre: {
                        type: 'string',
                        uniforms: {
                            label: t`Fixer le genre`,
                            allowedValues: ["Homme", "Femme"],
                            transform: (value) => {
                                if(value==="Homme"){
                                    return t`Garçon`
                                }else{
                                    return t`Fille`
                                }
                            },
                        }
                    },
                }
            },
        },
    }
}
